import type { TCalendlyCancelOutcome, TReleaseInterviewPayload } from '@/services/interviews';
import type { TMemberEmailOutcome } from '@/hooks/emailSends';

import { INTERVIEW_RELEASE_PURPOSE, RESCHEDULED_ENDING, RESCHEDULED_OUTCOME } from '@/constants/interviewCall';
import { errorUtils } from '@/services/errors';
import { interviewsService } from '@/services/interviews';
import { notifyMember } from '@/hooks/emailSends';

type TCalendlyStep = TCalendlyCancelOutcome | 'failed';

type TReleaseVariables = TReleaseInterviewPayload & {
  applicantID: string;
};

type TInterviewRelease = {
  calendly: TCalendlyStep;
  letter: TMemberEmailOutcome;
};

const cancelCalendlyEvent = async ({ bookingID, outcome }: TReleaseVariables): Promise<TCalendlyStep> => {
  if (outcome !== RESCHEDULED_OUTCOME) {
    return 'skipped';
  }

  const result = await interviewsService.cancelEvent(bookingID, RESCHEDULED_ENDING);

  if (errorUtils.isNetworkError(result)) {
    return 'failed';
  }

  return result;
};

const releaseAndNotify = async (variables: TReleaseVariables): Promise<TInterviewRelease> => {
  const { bookingID, outcome, applicantID } = variables;

  errorUtils.unwrap(await interviewsService.releaseInterview({ bookingID, outcome }));

  const calendly = await cancelCalendlyEvent(variables);
  const letter = await notifyMember({ memberID: applicantID, purpose: INTERVIEW_RELEASE_PURPOSE[outcome] });

  return { calendly, letter };
};

export type {
  TCalendlyStep,
  TInterviewRelease,
  TReleaseVariables,
};
export {
  releaseAndNotify,
};
